import { createPersistedStore } from 'features/load-hub/hooks/createPersistedStore'

const STORAGE_KEY = 'box_truck_beon_enabled'

/**
 * "BEON loads" — the board's opt-in supplement answered from the operator's own BeOnCarrier connection.
 *
 * OFF by default, like DAT, but remembered WITHOUT the one-day expiry that choice carries, and the
 * difference is what each feed costs. DAT is a live search on Numeo's shared token pool, so a forgotten
 * "on" keeps spending a shared resource and has to lapse. BEON runs on the operator's OWN session — the
 * Firestore `beon` credential they connected themselves — so leaving it on costs nobody else anything,
 * and expiring it would just mean silently dropping a board they deliberately connected.
 *
 * It also cannot run away on its own. The switch does nothing until that connection exists, and when the
 * session dies LIS clears the credential (`invalidateOnAuthError`); the board then learns the connection is
 * gone and stops asking (`beonRequestable`), with the row explaining why in the place the switch lives.
 *
 * Stored as the string 'on' rather than JSON: there is no timestamp to keep, and anything else — no entry,
 * a stale value from another format — reads as off, which is the safe direction.
 */
export const useBoxTruckBeonEnabled = createPersistedStore<boolean>(
    STORAGE_KEY,
    (raw) => raw === 'on',
    (enabled) => (enabled ? 'on' : '')
)
